import { render, staticRenderFns } from "./PasswordForgotView.vue?vue&type=template&id=e047e0f2&scoped=true"
import script from "./PasswordForgotView.vue?vue&type=script&lang=js"
export * from "./PasswordForgotView.vue?vue&type=script&lang=js"
import style0 from "./PasswordForgotView.vue?vue&type=style&index=0&id=e047e0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e047e0f2",
  null
  
)

export default component.exports